/*!
* Modal journal
*/

const $body = $('body');
const wrap = '.journal';
const tabs = '.tabs';
const tabsTitle = '.tabs-title';
const active = '.is-active';
const next = '.swiper-controls__next';
const back = '.swiper-controls__back';

/**
 * Sets listens for events
 */
let setUpListens = () => {
	let lengthList = $(`${tabs} ${tabsTitle}`, wrap).length;

	$body.on('click', `${wrap} ${next}`, () => {
		let nextIndex = $(`${tabs} ${active}`, wrap).index() + 1;

		if (nextIndex === lengthList) {
			nextIndex = 0;
		}

		$(`#panel${nextIndex}-label`).click();
	});

	$body.on('click', `${wrap} ${back}`, () => {
		let backIndex = $(`${tabs} ${active}`, wrap).index() - 1;

		if (backIndex < 0) {
			backIndex = lengthList - 1;
		}

		$(`#panel${backIndex}-label`).click();
	});
};

/**
 * Init list
 */
let init = () => {
	setUpListens();
};

export {init as initJournal};
